import { render, staticRenderFns } from "./DashboardLeaveCard.vue?vue&type=template&id=a5523842"
import script from "./DashboardLeaveCard.vue?vue&type=script&lang=js"
export * from "./DashboardLeaveCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports